import {LINEAREALTIME} from './LineaRealTimeTypes'

export const changeLineaRealTime = lineaRealTime => {
    return {
        type: LINEAREALTIME,
        load: lineaRealTime
    }
}

export const selectNewLineaRealTime = (lineaRealTime) => {

    return (dispatch) => {
        dispatch(changeLineaRealTime(lineaRealTime))
    }

}